import {
  BoarderResponseDetail, DiscountResponse,
  RatingStatisticDetailResponse,
  RatingStatisticsResponse,
  RatingSummaryByDayResponse,
  RatingValueResponse,
} from "@/types/service-response";

export default class RatingStatisticDetail {
  private constructor(
      readonly boarder: BoarderResponseDetail,
      readonly date: string,
      readonly note: string | null,
      readonly value: number
  ) {}


  static createFromResponse(responseData: RatingStatisticDetailResponse[]): RatingStatisticDetail[] {
    return responseData.map((item:RatingStatisticDetailResponse) => {
    return new RatingStatisticDetail(
      item.boarder,
      item.date,
      item.note,
      item.value,
    )
    })
  }
}
